module.exports = __webpack_public_path__ + "static/lightbox-864ad5a6138a32c00354345e03dcfe92.jpg";